import translate from '../../Translations/index';
import Notification from '../../../Library/notification';
import {GET_INFORMATION_ATTRIBUTES} from '../Queries/informationAttribute';

class InformationAttribute {

    constructor(props){
        this.props = props;
    }

    addInformationAttribute(addInformationAttribute,formData){

        if(formData.name != ""){
                       
            addInformationAttribute({
                variables:formData
            }); 

        }else{
            let notify = new Notification();
            notify.setNotification(null,translate.t("InvalidInformationAttributeName"),false,true,this.props.client);
        }
                              
    }

    getData(data,informationAttributeID,formData,setFormData){

        if(informationAttributeID != 0){
            
            setFormData({...formData,
                
                name: data.informationAttribute.name,
                informationAttributeID: data.informationAttribute.informationAttributeID
                
            });
        }

    }

    updateAfterDelete(cache, response){

        var resp = response.data.deleteInformationAttributes.split(",");

        const { allInformationAttributes } = cache.readQuery({ query: GET_INFORMATION_ATTRIBUTES});
        var arr = [...allInformationAttributes];

        resp.forEach((it,ind) => {
            arr.forEach((item,index) => {
                if(item.informationAttributeID == it){
                    arr = [...arr.slice(0,index),...arr.slice(index + 1)]
                }
            });
        }) 
    
        cache.writeQuery({ 
            query:GET_INFORMATION_ATTRIBUTES,
            data:{
                allInformationAttributes: [...arr],
            } 
        });

    }

    updateList(cache, response,informationAttributeID){

        const { allInformationAttributes } = cache.readQuery({ query: GET_INFORMATION_ATTRIBUTES});
  
        if(informationAttributeID && informationAttributeID != 0){

            var arr = [...allInformationAttributes];

            arr.forEach((item,index) => {
                
                if(item.informationAttributeID == response.data.addEditInformationAttribute.informationAttributeID){
                    arr[index] = response.data.addEditInformationAttribute;
                }

            });

            cache.writeQuery({ 
                query:GET_INFORMATION_ATTRIBUTES,
                data:{
                    allInformationAttributes: arr
                } 
            });

        }else{
            var arr = [response.data.addEditInformationAttribute,...allInformationAttributes];

            cache.writeQuery({ 
                query:GET_INFORMATION_ATTRIBUTES,
                data:{
                    allInformationAttributes: arr
                } 
            });
        }

    }


    /**
     * funkce ukládá data, která byla vložena do formuláře
     * @param {*} e ukazatel na element
     * @param {Function} setFormData funkce nastavující data formulare
     */
    
    formHandle(e,formData,setFormData){
	  
        const t = e.target;
        const v = t.type === 'checkbox' ? t.checked : t.value;
        const n = t.name;
        
        setFormData({...formData,[n]: v});
              
    }

}

export default InformationAttribute;